import React, {useState, Fragment} from 'react';

function ErrorsList({errors, formFn, setActiveKey}){
  
  const [count, setCount] = useState(0);

  formFn.refreshErrorsList = () =>{
    setCount(value => ++value)
  }

  let goToErrorField = (error) =>{
    setActiveKey(`${error.tab_index}`); 
    setTimeout(function() {
      try{
        let ele = document.getElementById(`label_${error.id}`)
        ele.scrollIntoView();
        ele.style.border = '1px solid red'
      }catch(e){

      }
    }, 250); 
  }

  if(!errors.isSubmitted)return null;

  return(
    <div className="clearfix">
      <h5 id="error_list" className="error-field">These fields must be filled to submit this form</h5>
      {Object.keys(errors).map((key, i) => (
        errors[key].required && errors[key].invalid && 
          <div className="error-field col-xs-12 col-sm-6" key={i} onClick={e=>goToErrorField(errors[key])}>
            {<span>{errors[key].label}</span>}
          </div>
      ))}
    </div>
  )

}

export default ErrorsList;